import React, { useEffect } from 'react';

interface ToastProps {
    message: string;
    onClose: () => void;
    duration?: number;
    variant?: "alert-success" | "alert-error";
}

export const Toaster: React.FC<ToastProps> = ({
    message,
    onClose,
    duration = 3000,
    variant = "alert-error",
}) => {
    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [onClose, duration]);

    if (!message) return null;

    return (
        <div className="toast toast-top toast-center">
            <div className={`alert ${variant}`}>
                <span>{message}</span>
            </div>
        </div>
    );
};
